import { BodilColor } from '~src/branding';
import { Anchor } from '~src/components/Anchor';
import { Text } from '~src/components/Typography';
import { BODIL_ENERGI } from '~src/constants';
import { useBranding } from '~src/context/BrandingContext';
import { useDisplayContext } from '~src/context/DisplayContext';

import edcLogo from '~shared-assets/images/edc-logo.png';

import { HeaderButtons, Links } from './common';
import { HeaderBodil, Logo, LogoEDC, LogoSubtitleEDC, LogoWrapperEDC } from './style';
import { Props } from './types';

export const CalculatorHeader = (props: Props) => {
  const { isMobile, leadOrigin } = useDisplayContext();
  const { darkColor: backgroundColor, contrastLogoURL } = useBranding();

  const logoStyle = {
    width: '114px',
    left: isMobile ? '20px' : '60px',
  };

  return (
    <HeaderBodil style={{ backgroundColor }}>
      <HeaderButtons {...props} />
      {leadOrigin === 'edc' ? (
        <EDCLogo />
      ) : (
        <Anchor newTab href={BODIL_ENERGI}>
          <Logo style={logoStyle} src={contrastLogoURL} />
        </Anchor>
      )}
      <Links />
    </HeaderBodil>
  );
};

const EDCLogo = () => {
  const { isMobile } = useDisplayContext();

  const { contrastLogoURL } = useBranding();

  return (
    <LogoWrapperEDC {...{ isMobile }}>
      <Anchor newTab href={BODIL_ENERGI}>
        <LogoEDC src={contrastLogoURL} />
      </Anchor>
      <LogoSubtitleEDC>
        <Text level={2} style={{ whiteSpace: 'nowrap', color: BodilColor.base.grey }}>
          i samarbejde med
        </Text>
        <img src={edcLogo} width='40px' height='40px' alt='edc logo' />
      </LogoSubtitleEDC>
    </LogoWrapperEDC>
  );
};
